import styled, { css } from 'styled-components';
import spacing from '../../../../styles/spacing';
import { vars } from '../../../../theme';

const titleElementStyles = css`
    flex-shrink: 0;
    margin-right: ${spacing[8]};
`;

export const StyledColumnHeaderContainer = styled.div`
    padding: 5px ${spacing[4]} 5px ${spacing[8]};
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const StyledColumnTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: ${spacing[2]};
`;

export const StyledTitleWithIcon = styled.div<{ $groupColor?: string }>`
    display: flex;
    align-items: center;

    ${({ $groupColor }) =>
        $groupColor
            ? css`
                  &::before {
                      content: '';
                      width: 3px;
                      height: 12px;
                      background-color: ${$groupColor};
                      border-radius: ${vars.radius.full};
                      ${titleElementStyles}
                  }
              `
            : ''}
`;

export const StyledColumnTitleText = styled.div``;

export const StyledItemCount = styled.div`
    padding: ${spacing[2]} ${spacing[6]};
    margin-top: 1px;
    min-width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const StyledIconWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-top: 3px;
    ${titleElementStyles}
`;
